<template>
  <div>
    <h1>Integrations</h1>

    <div v-for="(integrations, index) in groupedIntegrationList" :key="index" class="row">
      <div v-for="(integration, intIndex) in integrations" :key="intIndex" class="col-lg-4">
        <IntegrationPanel
          :name="integration.name"
          :code="integration.code"
          :description="integration.description"
          :image="integration.imagePath"
          :installed="integration.isInstalled"
          :enabled="integration.isEnabled"
          :configEnabled="true"
          @config="displayIntegrationConfiguration(integration)"
          @connect="connectIntegration(integration)"
          @disconnect="disconnectIntegration(integration)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import IntegrationPanel from '@/modules/admin/components/integrationPanel.vue'
import ProcessingDialog from '@/components/dialog/processingDialog.vue'

import { setTimeout } from 'timers'
import { IntegrationTypeCodes } from '@/store/types'

// Integrations
import XeroConfigDialog from '@/integrations/xero/views/xeroConfigDialog'


export default {
  name: "IntegrationList",
  components: {
    IntegrationPanel
  },
  data: () => {
    return {
      integrationList: []
    }
  },
  computed: {
    groupedIntegrationList() {
      return _.chunk(this.$data.integrationList, 3)
    }
  },
  mounted() {
    this.requestData()

    // Note: This doesn't show up smoothly (probably due to document not ready yet)
    // but hopefully when we query for the integration list, by then we can display this connection dialog
    // Then it'll all work nicely

      // Check for integration completion
      if(this.$route.query.connect == '1' && this.$route.query.integration != null) {

        // Directly using Xero for now
        // TODO: In future check the integration type & run the right process
        this.$nextTick(() => {
          this.displayModal(ProcessingDialog, {
            title: 'Connecting to Xero',
            message: 'Connecting Synergy to Xero',
            onBeforeOpen: (instance) => {
              this.$apiService.coreService.connectIntegration('xero', this.$route.query)
              .then(() => {
                this.successToast('Connected to Xero')

                instance.hide()

                // Refresh page again
                this.requestData()

                // Refresh profile as it contains integration info
                // TODO: Some way to handle this globally?
                // Or subscribe to updates via Socket.io style?
                this.$api.get("/profile").then(response => {
                  this.$store.commit("profile/setProfile", response.data);
                })
              })
              .catch(err => {
                instance.hide()
                var errorMsg = _.get(err, 'data.error.message')
                this.errorMessage('Failed to connect', 'The following error occured while attempting to connect to Xero\n' + errorMsg)
              })
            }
          })
          .then(() => {
          })
        })
      }   
  },
  methods: {
    requestData() {
      this.$apiService.adminService.getIntegrationList().then(response => {
        this.$data.integrationList = response.data
      })
    },
    connectIntegration(integration) {
      this.displayModal(ProcessingDialog, {
        title: 'Redirecting',
        message: `Redirecting to ${integration.name} login...`,
        onBeforeOpen: (instance) => {
          this.$apiService.coreService.getIntegrationConnectLink(integration.code)
          .then((resp) => {
            setTimeout(() => {
              window.location.href = resp.data.link
            }, 1000)
          })
          .catch(err => {
            instance.hide()
            this.displayNetworkError(err, 'Failed to connect', 'Error while attempting to connect to Xero')
          })
        }
      })
      .then(() => {
      })
    },
    disconnectIntegration(integration) {
      this.confirmDeleteMessage(`Disconnect ${integration.name}?`, 'Are you sure you want to disconnect this integration? ')
      .then(success => {
        if(success) {      
          this.$apiService.coreService.disconnectIntegration(integration.code)
            .then((resp) => {
              this.requestData()
              this.successToast(`${integration.name} disconnected`)

              // Refresh profile as it contains integration info
              // TODO: Some way to handle this globally?
              // Or subscribe to updates via Socket.io style?
              this.$api.get("/profile").then(response => {
                this.$store.commit("profile/setProfile", response.data);
              })
            })
        }
      })
    },
    displayIntegrationConfiguration(integration) {
      switch(integration.code) {
        case IntegrationTypeCodes.xero:
          this.displayModal(XeroConfigDialog)
          .then(success => {
            if(success)
              this.successToast(`Xero Configuration Updated`)
          })        
          break
      }      
    }
  }
};
</script>
